import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FileUploader } from 'ng2-file-upload';
import { ToasterService } from 'angular2-toaster';
import { KitService } from '../../services/kit.service';
import { GlobalConstantsService } from '../../services/global-constants.service';
import { GroupsService } from '../../services/groups.service';
import { StatService } from '../../services/stat.service';
import {Kit} from '../../services/kit';
import {toFormObject} from '../../services/utils';

@Component({
  selector: 'kit',
  templateUrl: './kit.component.html',
  styleUrls: ['./kit.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class KitComponent {

  @Input() kit;

}


export function createKitForm(kit: Kit = null) {

  if (kit) {
    return mapKitToForm(kit);
  } else {
    return {
      id: null,
      name: '',
      description: '',
      thumbnail: '',
      banner: '',
      ord: null,
      public: 0,
      featured: 0,
      style_id: 1,
      code: '',
      groups: [],
      fields: [
        {
          label: 'AEP_FILE',
          value: 'value',
          type: 'text',
          engine_id: 'aep_file',
          ord: 0
        }
      ]
    }
  }
}

export function mapKitToForm(kit: Kit) {
  return toFormObject({
    id: kit.id,
    name: kit.name,
    description: kit.description,
    thumbnail: kit.thumbnail_relative || '',
    banner: kit.banner_relative || '',
    ord: kit.ord,
    public: kit.isPublic,
    featured: kit.isFeatured,
    style_id: kit.style.id,
    fields: kit.fields,
    code: kit.code,
    groups: kit.groups || [],
    updated_at: kit.updated_at,
    created_at: kit.created_at,
  });
}


// WEBPACK FOOTER //
// ./src/app/components/kit/kit.component.ts